import { EXPRESSIONS, PASTORS_CIRCLE } from "@/content/expressions";
import { cn } from "@/lib/cn";
import { Link } from "@/router/Router";
import { Container, SectionHeading } from "@/components/ui/Primitives";
import { Reveal } from "@/components/motion/Reveal";
import { Icon } from "@/components/ui/Icon";

/** Expressions: editorial index of the ministries, with Pastor's Circle featured. */
export function Expressions() {
  return (
    <section className="expr-section" aria-labelledby="expr-title">
      <Container>
        <SectionHeading
          eyebrow="Expressions"
          index="08"
          id="expr-title"
          title={
            <>
              A place for <em>every season</em>
            </>
          }
          lead="Communities within the tribe for leaders, ministers, women, singles — and partners in the vision."
        />
        <div className="expr-grid">
          <Reveal className="expr-feature" variant="scale">
            <Link to="/pastors-circle" className="expr-feature__link">
              <span className="expr-feature__glow" aria-hidden />
              <span className="eyebrow eyebrow--flame">Partners in the vision</span>
              <span className="expr-feature__name">{PASTORS_CIRCLE.name}</span>
              <span className="expr-feature__text">{PASTORS_CIRCLE.lead}</span>
              <span className="expr-feature__cta">
                Discover Pastor's Circle <Icon name="arrowRight" size={16} />
              </span>
            </Link>
          </Reveal>
          <ol className="expr-list">
            {EXPRESSIONS.map((e, i) => (
              <Reveal as="li" key={e.slug} delay={i * 60}>
                <Link to={`/expressions/${e.slug}`} className={cn("expr-row", `expr-row--${e.accent}`)}>
                  <span className="expr-row__num">0{i + 1}</span>
                  <span className="expr-row__short">{e.short}</span>
                  <span className="expr-row__name">
                    {e.name !== e.short ? e.name : e.summary.replace(/^An expression for /i, "For ")}
                    <span className="expr-row__aud">{e.audience}</span>
                  </span>
                  <Icon name="arrowUpRight" size={20} className="expr-row__arrow" />
                </Link>
              </Reveal>
            ))}
            <Reveal as="li" delay={EXPRESSIONS.length * 60}>
              <Link to="/connect/believers-academy" className="expr-row expr-row--leaf">
                <span className="expr-row__num">0{EXPRESSIONS.length + 1}</span>
                <span className="expr-row__short">Academy</span>
                <span className="expr-row__name">
                  Believers Academy
                  <span className="expr-row__aud">Saturdays · 7–9 AM</span>
                </span>
                <Icon name="arrowUpRight" size={20} className="expr-row__arrow" />
              </Link>
            </Reveal>
          </ol>
        </div>
      </Container>
    </section>
  );
}
